// 引入dayjs 封装一些功能
import dayjs from 'dayjs'
import moment from 'moment'

// 加载 中文 语言包
import 'dayjs/locale/zh-cn' // ES 2015
dayjs.locale('zh-cn') // 全局使用

// 引入一个插件。在npm i dayjs 时，就已经把这个插件下载到了本地
// 引入它， 以增强dayjs的能力---计算相对时间。
var rTime = require('dayjs/plugin/relativeTime')
dayjs.extend(rTime)

export const formatTime = (val) => {
  return dayjs(val).format('YYYY/MM/DD')
}

export const formatMoment=(val=>{
  return moment(val).format('YYYY/MM/DD')
})

export const formatMomentOther = (val) => {
  return moment(val).format('YYYY.MM.DD')
}

export const formatDateTime=(val=>{
  return dayjs(val).format('YYYY.MM.DD HH:mm:ss')
})

export const formatDateMoment=(val=>{
  return  moment(val).format('YYYY.MM.DD HH:mm:ss')
})

export const relativeTime = yourTime => {
  // 用dayjs提供的api对yourTime进行格式化，以获取一个相对时间
  return dayjs().to(dayjs(yourTime))
}

export const relativeMoment = yourTime => {
  // 用dayjs提供的api对yourTime进行格式化，以获取一个相对时间
  return moment().to(moment(yourTime))
}

export const relativeTimeNumber = yourTime => {
  // 用dayjs提供的api对yourTime进行格式化，以获取一个相对时间
  return dayjs().diff(dayjs(yourTime), 'days')
}

export const relativeMomentNumber = yourTime => {
  // 用dayjs提供的api对yourTime进行格式化，以获取一个相对时间
  return moment().diff(moment(yourTime), 'days')
}
